module.exports = __webpack_public_path__ + "static/media/monkey.071b38dd.png";